function renderBuildGroupFieldsJsxTabContentTemplate({
  tName,
  tabFields
}: {
  tName: string
  tabFields: string
}): string {
  return `              <TabsContent value="${tName}" className="space-y-6">
${tabFields}
              </TabsContent>`
}

function renderBuildGroupFieldsJsxTabsLayoutTemplate({
  indent,
  toPascalCase,
  tabsList,
  tabsContent
}: {
  indent: string
  toPascalCase: string
  tabsList: string
  tabsContent: string
}): string {
  return `${indent}<Tabs value={activeTab} onValueChange={(value) => void setActiveTab(value as ${toPascalCase}TabValue)} className="w-full">
              <TabsList>
${tabsList}
              </TabsList>
${tabsContent}
${indent}</Tabs>`
}

export function renderSingleFormBuildGroupFieldsJsxRenderer(
  request:
    | {
        kind: 'renderBuildGroupFieldsJsxTabContentTemplate'
        props: {
          tName: string
          tabFields: string
        }
      }
    | {
        kind: 'renderBuildGroupFieldsJsxTabsLayoutTemplate'
        props: {
          indent: string
          toPascalCase: string
          tabsList: string
          tabsContent: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderBuildGroupFieldsJsxTabContentTemplate':
      return renderBuildGroupFieldsJsxTabContentTemplate(request.props)
    case 'renderBuildGroupFieldsJsxTabsLayoutTemplate':
      return renderBuildGroupFieldsJsxTabsLayoutTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
